// util/passwordPolicy.ts
export const PASSWORD_REGEX =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{}|;:'.,<>/?])[A-Za-z\d!@#$%^&*()_+\-=\[\]{}|;:'.,<>/?]{8,}$/;
